import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import DepartmentService from "../../services/Department/DepartmentService";
import { motion } from "framer-motion";

const DepartmentBanner = ({emitDepartmentDetails}) => {
  const params = new URLSearchParams(window.location.search);

  
  const [isLoading, setIsLoading] = useState(false);
  const [department, setDepartment] = useState([]);

  useEffect(() => {
    fetchDepartment();
  }, []);

  const fetchDepartment = () => {
    setIsLoading(true)
    DepartmentService.GetById()
      .then(response => {
        setDepartment(response.data)
        if(emitDepartmentDetails) {
          emitDepartmentDetails(response.data)
        }
        setIsLoading(false)
      })
      .catch(error => {
        setIsLoading(false)
        console.error('Error fetching page content:', error);
      })
  };
  
  return (
    isLoading ? (
      <div className="text-center py-4">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-2">Loading department information...</p>
      </div>
    ) : department ? (
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="mb-0"
      >
        <div className="card border-0 rounded-0" style={{
          boxShadow: '0 2px 15px rgba(0, 0, 0, 0.06)'
        }}>
          <div style={{
            background: 'white',
            padding: '2.5rem 2rem',
            position: 'relative'
          }}>
            {department.deptName && (
              <div className="text-center mb-4">
                <h1 style={{ 
                  fontSize: '2.2rem', 
                  fontWeight: '600',
                  color: '#333',
                  letterSpacing: '0.5px',
                  textTransform: 'uppercase',
                  marginBottom: '15px'
                }}>{department.deptName}</h1>
                <div style={{ 
                  width: '100px', 
                  height: '3px', 
                  background: '#333', 
                  margin: '0 auto',
                  marginBottom: '20px'
                }}></div>
              </div>
            )}
            
            <div className="row">
              <div className="col-12">
                {department.description && (
                  <p className="lead text-center mb-0" style={{ 
                    fontSize: "1.1rem", 
                    lineHeight: "1.7",
                    color: "#555",
                    maxWidth: "1200px",
                    margin: "0 auto"
                  }}>
                    {department.description}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    ) : null
  );
};

export default DepartmentBanner;


